import { render, staticRenderFns } from "./our-advantage.vue?vue&type=template&id=787bc68c&scoped=true&"
import script from "./our-advantage.vue?vue&type=script&lang=js&"
export * from "./our-advantage.vue?vue&type=script&lang=js&"
import style0 from "./our-advantage.vue?vue&type=style&index=0&id=787bc68c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "787bc68c",
  null
  
)

export default component.exports